"use client";

import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";
import { getDashboardRouteFrameState } from "@/components/dashboard/dashboard-route-frame-state";

function useDashboardRouteFrameState() {
  return getDashboardRouteFrameState(usePathname());
}

export function DashboardViewportFrame({ children }: React.PropsWithChildren) {
  const frame = useDashboardRouteFrameState();
  return (
    <div
      className={cn(
        "findin-dashboard-shell relative flex min-h-0 max-w-screen flex-col",
        frame.viewportClassName,
      )}
      data-writer-dashboard-viewport={frame.writerRoute || undefined}
    >
      {children}
    </div>
  );
}

export function DashboardSidebarFrame({ children }: React.PropsWithChildren) {
  const frame = useDashboardRouteFrameState();
  return (
    <div
      className={frame.sidebarClassName}
      data-writer-dashboard-sidebar-frame={frame.writerRoute || undefined}
    >
      {children}
    </div>
  );
}

export function DashboardMainFrame({ children }: React.PropsWithChildren) {
  const frame = useDashboardRouteFrameState();
  return (
    <main
      className={cn(
        "flex min-h-0 flex-1 flex-col overflow-hidden bg-muted",
        frame.mainClassName,
      )}
      data-writer-dashboard-main={frame.writerRoute || undefined}
    >
      {children}
    </main>
  );
}
